import { render, staticRenderFns } from "./LuggagePopOver.vue?vue&type=template&id=03eff4f0&scoped=true&"
import script from "./LuggagePopOver.vue?vue&type=script&lang=js&"
export * from "./LuggagePopOver.vue?vue&type=script&lang=js&"
import style0 from "./LuggagePopOver.vue?vue&type=style&index=0&id=03eff4f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eff4f0",
  null
  
)

export default component.exports